import axios from 'axios';
import { BaseAPI } from './BaseAPI';

export class GovApplyAPI extends BaseAPI {
  /*商社通接口 */

  //第一步檢驗信息
  async govApplyBasic(value, isApp = true) {
    const { data } = await axios.post(
      `${this._getBasePathPublic()}/association-business/${isApp}/submit/basic`,
      value
    );
    return data;
  }

  //提交場所申請
  async govApplySubmit(value, interconnect, otp, isApp = true) {
    const { data } = await axios.post(
      `${this._getBasePathPublic()}/association-business/${isApp}/submit?interconnect=${interconnect}&otp=${otp}`,
      value
    );
    return data;
  }

  //獲取申請詳情
  async govApplyQuery(cardNoOrTaxNo, applicationNo, mobile, otp, isApp = true) {
    const { data } = await axios.get(
      `${this._getBasePathPublic()}/association-business/${isApp}/query?cardNoOrTaxNo=${cardNoOrTaxNo}&applicationNo=${applicationNo}&mobile=${mobile}&otp=${otp}`
    );
    return data;
  }

  //查詢獲取申請詳情
  async govQueryDetail(cardNoOrTaxNo, applicationNo, expire, signature, isApp = true) {
    const { data } = await axios.get(
      `${this._getBasePathPublic()}/association-business/${isApp}/sign/query?cardNoOrTaxNo=${cardNoOrTaxNo}&applicationNo=${applicationNo}&expire=${expire}&signature=${signature}`
    );
    return data;
  }

  //查詢我的列表
  async govMyApplication(params, isApp = true) {
    const { data } = await axios.get(
      `${this._getBasePathPublic()}/association-business/${isApp}/myApplication`,
      {
        params: params,
      }
    );
    return data;
  }

  //根据ID获取申请详情
  async govQueryById(id, isApp = true) {
    const { data } = await axios.get(
      `${this._getBasePathPublic()}/association-business/${isApp}/queryById?id=${id}`
    );
    return data;
  }

  //下载预先通知凭证
  async downloadAdvance(applicationNo, isApp = true) {
    const { data } = await axios.get(
      `${this._getBasePathPublic()}/association-business/${isApp}/download/advance?applicationNo=${applicationNo}`,
      { responseType: 'blob' }
    );
    return data;
  }

  //商社通證件類型
  async getPersonalInformation(isApp = true) {
    const { data } = await axios.get(
      `${this._getBasePathPublic()}/association-business/${isApp}/personal-information`);
    return data;
  }

  //文件必傳校驗
    async validateDocuments(applicationNo, applicationType, companyType, isApp = true) {
      const { data } = await axios.post(
        `${this._getBasePathPublic()}/association-business/${isApp}/submit/documents/${applicationNo}?companyType=${companyType}&applicationType=${applicationType}`
      );
      return data;
    }

  //根据申请编号获取申请详情
  async govQueryByApplicationNo(applicationNo, isApp = true, confirmNo) {
    const { data } = await axios.get(
      `${this._getBasePathPublic()}/association-business/${isApp}/queryByApplicationNo?applicationNo=${applicationNo}&confirmNo=${confirmNo}`
    );
    return data;
  }

}
export default new GovApplyAPI({
  prefix: '',
  path: '/mo/application',
});
